var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.display)?_c('div',[_c('v-badge',{class:{
      'teacher-badge': (
        _vm.userType === 'teacher'
        && !_vm.isPointsBadge
      ),
      'student-badge': (
        _vm.userType !== 'teacher'
        && !_vm.isPointsBadge
      ),
      'points-badge': _vm.isPointsBadge,
    },attrs:{"value":_vm.shouldBadgeBeShown,"top":"","overlap":"","dot":"","color":(_vm.isPointsBadge && _vm.selectedBadgeColor) ? _vm.selectedBadgeColor.border : 'red'}},[_c('span',{directives:[{name:"dompurify-html",rawName:"v-dompurify-html",value:(!_vm.isPointsBadge ? '' : _vm.badgeText),expression:"!isPointsBadge ? '' : badgeText"}],style:({
        color: _vm.selectedBadgeColor.text
      }),attrs:{"slot":"badge"},slot:"badge"}),_c('div',{directives:[{name:"dompurify-html",rawName:"v-dompurify-html",value:(_vm.display),expression:"display"}],staticClass:"full-width"})])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }